import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-scorecards',
  templateUrl: './scorecards.component.html',
  styleUrls: ['./scorecards.component.scss'],
})
export class ScorecardsComponent implements OnInit {

	@Input() records: any[] = [];

	constructor(private modalCtrl: ModalController) { }

	ngOnInit() {
		console.log('Records:', this.records);
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
